import { BreadCrumb, MUIBox, MUITypography } from "@cobee/cobee-ui";
import auth0Client from "app/auth/Auth";
import { TFunction, useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import styles from "./styles";

// eslint-disable-next-line no-shadow
export enum V2RoutesEnum {
  EMPLOYEE_REQUESTS = "/v2/employee-requests",
  EMPLOYEE_REQUEST_DETAIL = "/v2/requests/detail",
}

const config = (url: string, t: TFunction) => {
  let customUrl = url;
  if (url.includes(V2RoutesEnum.EMPLOYEE_REQUEST_DETAIL)) {
    customUrl = V2RoutesEnum.EMPLOYEE_REQUEST_DETAIL;
  }
  switch (customUrl) {
    case V2RoutesEnum.EMPLOYEE_REQUESTS: {
      return {
        title: t("v2.section-titles.request-for-benefits"),
        subtitle: t(
          "v2.section-titles.review-the-benefits-requests-made-by-your-employees"
        ),
        breadCrumbItems: [
          {
            url: "/benefits",
            displayName: t("v2.previous-page-titles.benefits"),
          },
        ],
      };
    }
    case V2RoutesEnum.EMPLOYEE_REQUEST_DETAIL: {
      return {
        title: t("v2.section-titles.request-management"),
        subtitle: t("v2.section-titles.review-your-employee-request"),
        breadCrumbItems: [
          {
            url: "/benefits",
            displayName: t("v2.previous-page-titles.benefits"),
          },
          {
            url: `/v2/employee-requests?companyId=${auth0Client.getCompanyId()}`,
            displayName: t("v2.section-titles.request-for-benefits"),
          },
          {
            url,
            displayName: t("v2.section-titles.request-management"),
          },
        ],
      };
    }
    default:
      return {};
  }
};

export default function LayoutHeader() {
  const { location } = useHistory();
  const { t } = useTranslation();

  const { backText, subtitleStyle } = styles;

  const getParams = () => {
    return config(location.pathname, t) || {};
  };

  const { title = "", subtitle = "", breadCrumbItems = [] } = getParams();

  return (
    <MUIBox
      sx={{
        pr: 7,
        pt: 3,
        pl: 16,
        pb: 3,
      }}
    >
      <MUIBox sx={backText}>
        <BreadCrumb items={breadCrumbItems} />
      </MUIBox>

      <MUITypography variant="h5">{title}</MUITypography>
      <MUITypography variant="body2" sx={subtitleStyle}>
        {subtitle}
      </MUITypography>
      {/* <Button size="small" variant="contained"> */}
      {/*  {t("v2.common.continue")} */}
      {/* </Button> */}
      {
        // This is a provisional spacing div to replace the commented button for aligning purposes
      }
      <div style={{ width: 80, height: 1 }} />
    </MUIBox>
  );
}
